import { createContext, useContext, useState, ReactNode } from 'react';

type AIEmailContextType = {
	loader: boolean;
	setLoader: (value: boolean) => void;
	emailData: any;
	setEmailData: (data: any) => void;
	showEmailBody: boolean;
	emailNameOptions: string[];
	setEmailNameOptions: (value: any[]) => void;
	setShowEmailBody: (value: boolean) => void;
	setSuggestedEmailName: (value: string) => void;
	suggestedEmailName:string;
};

const AIEmailContext = createContext<AIEmailContextType | undefined>(undefined);

export const AIEmailProvider = ({ children }: { children: ReactNode }) => {
	const [loader, setLoader] = useState(false);
	const [emailData, setEmailData] = useState<any>();
	const [showEmailBody, setShowEmailBody] = useState<boolean>(true);
	const [emailNameOptions, setEmailNameOptions] = useState([]);
	const [suggestedEmailName, setSuggestedEmailName] = useState('');


	return (
		<AIEmailContext.Provider
			value={{
				loader,
				emailData,
				showEmailBody,
				emailNameOptions,
				suggestedEmailName,
				setEmailNameOptions,
				setEmailData,
				setLoader,
				setShowEmailBody,
				setSuggestedEmailName
			}}
		>
			{children}
		</AIEmailContext.Provider>
	);
};

export const useAIEmailContext = () => {
	const context = useContext(AIEmailContext);
	if (!context)
		throw new Error('useAIEmailContext must be used inside AppProvider');
	return context;
};
